import "./index.css";

import lizardSound from "./lizard.mp3";

function playLizardSound() {
  const audio = new Audio(lizardSound);
  audio.preload = "auto";
  audio.currentTime = 0;
  audio.play().catch(() => {
  });
}

export function App() {
  return (
    <div
      style={{
        minHeight: "100dvh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background:
          "linear-gradient(135deg, #1e3c72 0%, #2a5298 50%, #1e3c72 100%)",
        backgroundSize: "400% 400%",
        animation: "bgShift 15s ease infinite",
      }}
    >
      <style>
        {`@keyframes bgShift { 0%{background-position:0% 50%} 50%{background-position:100% 50%} 100%{background-position:0% 50%} }`}
      </style>
      <button
        aria-label="Lizard button"
        onClick={playLizardSound}
        style={{
          width: 160,
          height: 160,
          borderRadius: "9999px",
          fontSize: 72,
          lineHeight: 1,
          border: "none",
          cursor: "pointer",
          background: "#1f2937",
          color: "#fff",
          boxShadow:
            "0 10px 20px rgba(0,0,0,.35), inset 0 2px 8px rgba(255,255,255,.06)",
          transition: "transform 80ms ease, box-shadow 120ms ease",
        }}
        onMouseDown={(e) => {
          e.currentTarget.style.transform = "scale(0.96)";
          e.currentTarget.style.boxShadow =
            "0 4px 10px rgba(0,0,0,.45), inset 0 4px 12px rgba(255,255,255,.08)";
        }}
        onMouseUp={(e) => {
          e.currentTarget.style.transform = "scale(1)";
          e.currentTarget.style.boxShadow =
            "0 10px 20px rgba(0,0,0,.35), inset 0 2px 8px rgba(255,255,255,.06)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "scale(1)";
          e.currentTarget.style.boxShadow =
            "0 10px 20px rgba(0,0,0,.35), inset 0 2px 8px rgba(255,255,255,.06)";
        }}
      >
        <span role="img" aria-label="lizard">
          🦎
        </span>
      </button>
    </div>
  );
}

export default App;
